<template>
  <div class="local-body d-flex justify-center align-center">
    <div style="position: relative">
      <hero-text></hero-text>
      <div class="d-flex justify-end" style="z-index: 99">
        <a @click="onClickNext">Next</a>
      </div>
    </div>
  </div>
</template>

<script>
// TODO: 구름하고 바다 움직이는거, 나묻도 살랑거리고
import HeroText from "./HeroText.vue";

export default {
  components: {
    HeroText,
  },
  async mounted() {
    this.tempFunc = setTimeout(() => {
      this.goToNext();
    }, 7000);
  },
  methods: {
    tempFunc: () => ({}),
    onClickNext() {
      clearInterval(this.tempFunc);
      this.goToNext();
    },
    goToNext() {
      this.$router.push("/login");
    },
  },
  destroyed() {
    clearInterval(this.tempFunc);
  },
};
</script>

<style scoped>
.pos-rel {
  position: relative;
}

.local-body {
  width: 100vw;
  height: 100vh;
  background-image: linear-gradient(
    to right top,
    #d16ba5,
    #c777b9,
    #ba83ca,
    #aa8fd8,
    #9a9ae1,
    #8aa7ec,
    #79b3f4,
    #69bff8,
    #52cffe,
    #41dfff,
    #46eefa,
    #5ffbf1
  );
}
</style>
